import Link from "next/link";
import { Logo } from "../logo";
import { UserMenu } from "./user-menu";

export function OrangeHeader() {
  return (
    <header className="top-0 left-0 z-20 absolute py-8 w-full">
      <div className="flex justify-between items-center mx-auto px-8 w-full container">
        <div className="flex flex-shrink-0 justify-between items-center w-full">
          <Link href="/" className="block w-[64px] lg:w-auto truncate">
            <Logo color="white" className="lg:w-[320px]" />
          </Link>
          <UserMenu />
        </div>
      </div>
    </header>
  );
}
